import { render, staticRenderFns } from "./LoginMessage.vue?vue&type=template&id=fcb9a0d8&scoped=true&"
import script from "./LoginMessage.vue?vue&type=script&lang=ts&"
export * from "./LoginMessage.vue?vue&type=script&lang=ts&"
import style0 from "./LoginMessage.vue?vue&type=style&index=0&id=fcb9a0d8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcb9a0d8",
  null
  
)

export default component.exports